import axios from 'axios';
import { isByokActive, geminiText } from './geminiByokService';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Get existing analysis for a project */
export async function getAnalysis(projectId) {
  const { data } = await axios.get(`${API}/script-intelligence/analysis/${projectId}`);
  return data;
}

/** Run a new script analysis (AI) */
export async function runAnalysis(analysisData) {
  if (isByokActive() && analysisData.script_content) {
    return await runAnalysisByok(analysisData);
  }
  const { data } = await axios.post(`${API}/script-intelligence/analyze`, analysisData);
  return data;
}

/** BYOK: Run analysis directly via browser → Gemini */
async function runAnalysisByok(analysisData) {
  const systemPrompt = `You are an expert script analyst and film industry consultant specializing in Indian cinema (Bollywood, Tollywood, Kollywood, and regional). You analyze screenplays and provide detailed, actionable intelligence.`;

  const userPrompt = `Analyze this screenplay and return a JSON object with the following structure:
{
  "risk_assessment": {
    "overall_risk_score": <1-10>,
    "budget_risk_level": "<low|medium|high|very_high>",
    "risk_factors": [{"factor": "", "severity": "", "mitigation": ""}],
    "total_estimated_shoot_days": <number>,
    "recommended_budget_range_cr": {"min": <number>, "max": <number>}
  },
  "quality_scorecard": {
    "overall_score": <1-100>,
    "conflict_strength": {"score": <1-10>, "notes": ""},
    "character_arcs": {"score": <1-10>, "notes": ""},
    "dialogue_quality": {"score": <1-10>, "notes": ""},
    "pacing": {"score": <1-10>, "notes": ""},
    "originality": {"score": <1-10>, "notes": ""},
    "emotional_impact": {"score": <1-10>, "notes": ""}
  },
  "genre_classification": {
    "primary_genre": "",
    "sub_genres": [],
    "tone": "",
    "target_audience": ""
  },
  "commercial_viability": {
    "market_potential": "<low|medium|high>",
    "strengths": [],
    "weaknesses": [],
    "comparable_films": []
  },
  "scene_breakdown": {
    "total_scenes": <number>,
    "interior_count": <number>,
    "exterior_count": <number>,
    "night_count": <number>
  }
}

SCRIPT:
${analysisData.script_content.substring(0, 8000)}

Return ONLY valid JSON, no markdown fences.`;

  const text = await geminiText(systemPrompt, userPrompt);
  // Parse JSON from response (strip any markdown fences)
  const cleaned = text.replace(/```json\s*/g, '').replace(/```\s*/g, '').trim();
  const analysis = JSON.parse(cleaned);
  return { analysis, source: 'byok' };
}

/** Estimate market potential (AI) */
export async function estimateMarket(marketData) {
  const { data } = await axios.post(`${API}/script-intelligence/estimate-market`, marketData);
  return data;
}

/** Estimate production requirements (AI) */
export async function estimateProduction(productionData) {
  const { data } = await axios.post(`${API}/script-intelligence/production-estimate`, productionData);
  return data;
}
